import "./LoadAnimation.css";

export default function LoadAnimation({onFinish}) {
  return <div className="loadContainer" onAnimationEnd={onFinish}>O</div>
}